// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clickable[data-v-6778ecf7] {
  cursor: pointer;
}
.clickable[data-v-6778ecf7]:not(:hover) .actions {
  display: none;
}
.row-item[data-v-6778ecf7] {
  border-radius: var(--6778ecf7-\\\$getStyles\\.rowItemBorderRadius);
  min-height: 29px;
}
.row-item[data-v-6778ecf7] .text-link {
  padding: var(--6778ecf7-\\\$getStyles\\.rowItemPadding);
}
.row-item[data-v-6778ecf7]:hover {
  background-color: #b1cae3;
}
.row-item[data-v-6778ecf7]:hover .i-text {
  color: #111827 !important;
}
.row-item[data-v-6778ecf7]:hover .i-icon {
  color: #111827;
  fill: #111827;
}
.selected[data-v-6778ecf7] {
  background-color: #8BB7E4;
}
.selected[data-v-6778ecf7] .i-text {
  color: #111827;
}
.selected[data-v-6778ecf7] .i-icon {
  color: #111827;
  fill: #111827;
}
.item-name-container[data-v-6778ecf7] {
  width: calc(100% - 0px) !important;
}
.item-name-container .span.i-text[data-v-6778ecf7] {
  max-width: 100%;
}
.invalid-label[data-v-6778ecf7] .i-text {
  color: #ef4444 !important;
}
.invalid-icon[data-v-6778ecf7] {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}
.invalid-icon[data-v-6778ecf7] .i-icon {
  color: #ef4444;
  fill: #ef4444;
}
.inline-name-input[data-v-6778ecf7] {
  flex: 1;
  min-width: 20px;
  width: 100%;
  outline: 1px solid #9ca3af;
  border-radius: 4px;
  background: transparent;
  cursor: text;
  white-space: nowrap;
  overflow: hidden;
}
.inline-name-input[data-v-6778ecf7]:focus {
  outline: none;
}
.inline-name-input[data-v-6778ecf7]:empty::before {
  content: attr(data-placeholder);
  color: #9ca3af;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/create-dashboard/ListConfigPanelRowItem.vue","webpack://./ListConfigPanelRowItem.vue"],"names":[],"mappings":"AAEA;EACE,eAAA;ACDF;ADIA;EACE,aAAA;ACDF;ADIA;EACE,+DAAA;EACA,gBAAA;ACDF;ADGE;EACE,oDAAA;ACDJ;ADIE;EACE,yBAAA;ACFJ;ADII;EACE,yBAAA;ACFN;ADKI;EACE,cAAA;EACA,aAAA;ACHN;ADQA;EACE,yBAAA;ACLF;ADOE;EACE,cAAA;ACLJ;ADQE;EACE,cAAA;EACA,aAAA;ACNJ;ADUA;EACE,kCAAA;ACPF;ADSE;EACE,eAAA;ACPJ;ADYE;EACE,yBAAA;ACTJ;ADaA;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;ACVF;ADYE;EACE,cAAA;EACA,aAAA;ACVJ;ADcA;EACE,OAAA;EACA,eAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;ACXF;ADaE;EACE,aAAA;ACXJ;ADcE;EACE,+BAAA;EACA,cAAA;EACA,oBAAA;ACZJ","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.clickable {\n  cursor: pointer;\n}\n\n.clickable:not(:hover) :deep(.actions) {\n  display: none;\n}\n\n.row-item {\n  border-radius: v-bind(\"$getStyles.rowItemBorderRadius\");\n  min-height: 29px;\n\n  :deep(.text-link) {\n    padding: v-bind(\"$getStyles.rowItemPadding\");\n  }\n\n  &:hover {\n    background-color: #b1cae3;\n\n    :deep(.i-text) {\n      color: #111827 !important;\n    }\n\n    :deep(.i-icon) {\n      color: #111827;\n      fill: #111827;\n    }\n  }\n}\n\n.selected {\n  background-color: #8BB7E4;\n\n  :deep(.i-text) {\n    color: #111827;\n  }\n\n  :deep(.i-icon) {\n    color: #111827;\n    fill: #111827;\n  }\n}\n\n.item-name-container {\n  width: calc(100% - 0px) !important;\n\n  .span.i-text {\n    max-width: 100%;\n  }\n}\n\n.invalid-label {\n  :deep(.i-text) {\n    color: #ef4444 !important;\n  }\n}\n\n.invalid-icon {\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n\n  :deep(.i-icon) {\n    color: #ef4444;\n    fill: #ef4444;\n  }\n}\n\n.inline-name-input {\n  flex: 1;\n  min-width: 20px;\n  width: 100%;\n  outline: 1px solid #9ca3af;\n  border-radius: 4px;\n  background: transparent;\n  cursor: text;\n  white-space: nowrap;\n  overflow: hidden;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:empty::before {\n    content: attr(data-placeholder);\n    color: #9ca3af;\n    pointer-events: none;\n  }\n}\n",".clickable {\n  cursor: pointer;\n}\n\n.clickable:not(:hover) :deep(.actions) {\n  display: none;\n}\n\n.row-item {\n  border-radius: v-bind(\"$getStyles.rowItemBorderRadius\");\n  min-height: 29px;\n}\n.row-item :deep(.text-link) {\n  padding: v-bind(\"$getStyles.rowItemPadding\");\n}\n.row-item:hover {\n  background-color: #b1cae3;\n}\n.row-item:hover :deep(.i-text) {\n  color: #111827 !important;\n}\n.row-item:hover :deep(.i-icon) {\n  color: #111827;\n  fill: #111827;\n}\n\n.selected {\n  background-color: #8BB7E4;\n}\n.selected :deep(.i-text) {\n  color: #111827;\n}\n.selected :deep(.i-icon) {\n  color: #111827;\n  fill: #111827;\n}\n\n.item-name-container {\n  width: calc(100% - 0px) !important;\n}\n.item-name-container .span.i-text {\n  max-width: 100%;\n}\n\n.invalid-label :deep(.i-text) {\n  color: #ef4444 !important;\n}\n\n.invalid-icon {\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n.invalid-icon :deep(.i-icon) {\n  color: #ef4444;\n  fill: #ef4444;\n}\n\n.inline-name-input {\n  flex: 1;\n  min-width: 20px;\n  width: 100%;\n  outline: 1px solid #9ca3af;\n  border-radius: 4px;\n  background: transparent;\n  cursor: text;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.inline-name-input:focus {\n  outline: none;\n}\n.inline-name-input:empty::before {\n  content: attr(data-placeholder);\n  color: #9ca3af;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
